import React from 'react';
import PropTypes from 'prop-types';
const get = require('lodash/get');

const Strings = require('../../../../app/shared/Strings');
const Globals = require('../../../../app/globals');
const AssetUtil = require('../../util/asset');
const KeyboardUtil = require('../../util/keyboard');
const StringUtil = require('../../../../app/shared/StringUtil');
import AssetImage from '../common/AssetImage';

const propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func,
    interactable: PropTypes.bool,
    license: PropTypes.shape({
        token: PropTypes.string.isRequired,
        cost: PropTypes.number.isRequired,
        license_type_token: PropTypes.oneOf([Globals.ecommerce.course_license_types.INDIVIDUAL, Globals.ecommerce.course_license_types.INSTITUTION]),
        course_title: PropTypes.string.isRequired,
        course_display_title: PropTypes.string,
        course_hash: PropTypes.string.isRequired,
        course_image_url: PropTypes.string,
        course_description: PropTypes.string,
        course_license_meta_data: PropTypes.shape({
            subcompentency: PropTypes.bool,
            competency_name: PropTypes.string,
            competency_part: PropTypes.number,
            competency_total_parts: PropTypes.number,
            price: PropTypes.number,
        }).isRequired,
        issued_at: PropTypes.string,
        expires_at: PropTypes.string,
    }).isRequired,
};

const defaultProps = {
    className: '',
    onSelect: () => {},
    interactable: false,
};

function LicenseTile(props) {
    const courseTitle = props.license.course_display_title || props.license.course_title;
    const competencyName = get(props.license, 'course_license_meta_data.competency_name');
    const competencyPart = get(props.license, 'course_license_meta_data.competency_part');
    const competencyTotalParts = get(props.license, 'course_license_meta_data.competency_total_parts');
    const badgeImageUrl = get(props.license, 'course_license_meta_data.badge_image_url');
    const showPrice = props.license.license_type_token === Globals.ecommerce.course_license_types.INDIVIDUAL;
    const hasSale = !!props.license.sale_cost;
    return (
        <div
            key={props.license.token}
            className={`license-tile ${props.interactable ? 'license-tile-interactable' : ' '} ${props.className || ''}`}
            title={courseTitle}
            tabIndex="0"
            role="button"
            onClick={props.onSelect}
            onKeyDown={(e)=>{if (KeyboardUtil.isSelectKey(e.keyCode)) props.onSelect()}}
        >
            {(!!props.license.course_image_url) &&
                <div className="img-row">
                    <img className="license-img" src={AssetUtil.resolveAssetPath(props.license.course_image_url)} alt=" " aria-hidden />
                </div>
            }
            <div className="license-info">
                <span className="license-title">{courseTitle}</span>
                <div className="license-details">
                    <div className="license-text">
                        {(!!competencyName) &&
                            <div>
                                {competencyName}
                                {(!!competencyPart && !!competencyTotalParts) &&
                                    <span> {competencyPart}/{competencyTotalParts}</span>
                                }
                            </div>
                        }
                        {(!!props.license.cost && showPrice) &&
                            <div className="license-price">
                                <span className={(!hasSale) ? "price" : "price--strikeout"}>
                                    {StringUtil.formatUSD(props.license.cost)}
                                </span>
                                {(!!hasSale) &&
                                    <span className="price--sale margin-left-sm">
                                        {StringUtil.formatUSD(props.license.sale_cost)}
                                    </span>
                                }
                            </div>
                        }
                    </div>
                    <div className="license-badge">
                        {(!!badgeImageUrl) &&
                            <AssetImage
                                className="block parent-constrained"
                                src={badgeImageUrl}
                                alt={Strings['en'].short_course.skillbuild.BADGE_ALT_DEFAULT}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

LicenseTile.propTypes = propTypes;
LicenseTile.defaultProps = defaultProps;

export default LicenseTile;